<template>
  <div id="hydw">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'hydw'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/member/manage/company/Hydw.vue